<template>
  <dx-data-grid
    :show-borders="false"
    :show-column-lines="false"
    :show-row-lines="true"
    :showColumnHeaders="false"
    ref="ticketEventDataGrid"
    :data-source="dataSource"
    :columnAutoWidth="true"
    :hover-state-enabled="!gridTouch"
    :element-attr="gridAttr"
    style="max-height: 50vh"
  >
    <DxScrolling mode="virtual" />
    <DxSorting mode="none" />
  </dx-data-grid>
</template>

<script>
import axios from "axios";
import CustomStore from "devextreme/data/custom_store";
import { DxDataGrid, DxScrolling, DxSorting } from "devextreme-vue/data-grid";
import DataGridMixin from "@/mixins/DataGridMixin";

export default {
  components: {
    DxDataGrid,
    DxScrolling,
    DxSorting,
  },
  // nur für gridTouch (Hover nur bei Maus); das Scrollen bleibt virtuell über DxScrolling
  mixins: [DataGridMixin],
  props: ["ticket_id"],
  data() {
    return {
      gridAttr: {},
      dataSource: {
        store: new CustomStore({
          load: () =>
            axios.get(
              `${this.$store.state.baseUrl}eticket-ticket-event?ticket_id=${this.ticket_id}`
            ),
        }),
        reshapeOnPush: true,
      },
      columns: [],
    };
  },
  methods: {},
  async mounted() {},
  destroyed() {},
};
</script>

<style scoped></style>
